import { Component, ElementRef, ViewChild } from '@angular/core';
import { AnalyticUser } from './analytic-user.model';
import { TreeNode } from 'primeng/primeng';
import { isNull, isUndefined } from 'util';
import { RouterConst } from '../../../globals/RoutersConst';
import { BreadcrumbService } from '../../../breadcrumb.service';
import { ClientsService } from '../../../services/clients/clients.service';
import { SuperClass } from '../../../superclass/SuperClass';
import { DashboardDataService } from '../../../services/dashboard-data.service';
import { WsService } from '../../../services/websocket/WsService';
import { WsConst } from '../../../globals/WsConst';
import { CookieService } from 'ngx-cookie-service';
import { HttpClient } from '@angular/common/http';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';

@Component({
  selector: 'app-analytics-users',
  templateUrl: './analytics-users.component.html',
  styleUrls: ['./analytics-users.component.css'],
})
export class AnalyticsUsersComponent extends SuperClass {
  analyticsUsers: AnalyticUser[];

  securityGroups;
  defaultVenueGroup: TreeNode;
  allowedVenueGroups: TreeNode[];
  venueSelect: any = 'Choose venue';

  selectedRow: AnalyticUser;
  newAnalyticsUser: AnalyticUser;
  selectedRowForm: FormGroup;
  newAnalyticsUserForm: FormGroup;

  display = false;
  @ViewChild('op') op: ElementRef;
  venueGroupsTree;
  venueGroupsTreeAllowed;

  constructor(
    private breadcrumbService: BreadcrumbService,
    private dashboardDataService: DashboardDataService,
    private clientsService: ClientsService,
    private wsService: WsService,
    private httpClient: HttpClient,
    private cookiesService: CookieService,
    private fb: FormBuilder,
  ) {
    super(
      clientsService,
      wsService,
      dashboardDataService,
      httpClient,
      cookiesService,
    );

    this.breadcrumbService.setItems([
      { label: 'Organization' },
      {
        label: 'Analytics Users',
        routerLink: [{ outlets: { sub: [RouterConst.ANALYTICS_USERS] } }],
      },
    ]);
  }

  reloadData() {
    this.newAnalyticsUser = new AnalyticUser();

    this.reLoadUsers();

    this.http_getAllSecurityGroups((data: any) => {
      this.securityGroups = data.payload;
    });

    this.http_getTreeInfo(
      {
        withLocations: true,
        getAll: true,
        withNoParent: false,
        excludeId: 0,
      },
      (data: any) => {
        this.venueGroupsTree = JSON.parse(data.payload);
        this.venueGroupsTreeAllowed = JSON.parse(data.payload);
      },
    );

    this.selectedRowForm = this.fb.group({
      username: new FormControl('', Validators.required),
      securityGroup: new FormControl('', Validators.required),
    });

    this.newAnalyticsUserForm = this.fb.group({
      username: new FormControl('', Validators.required),
      password: new FormControl('', Validators.required),
      securityGroup: new FormControl('', Validators.required),
    });
  }

  selectRow(e) {
    if (!isUndefined(this.selectedRow) && e.data.id === this.selectedRow.id) {
      this.unselectRow();
      return;
    }

    this.selectedRow = new AnalyticUser(e.data);

    this.defaultVenueGroup = this.groupsToArr(this.venueGroupsTree).filter(
      el => {
        return el.data === this.selectedRow.defaultVenueGroup;
      },
    )[0];
    if (!isUndefined(this.defaultVenueGroup)) {
      this.venueSelect = this.defaultVenueGroup.label;
    } else {
      this.venueSelect = 'Choose venue';
    }

    this.allowedVenueGroups = this.groupsToAllowedArr(
      this.venueGroupsTreeAllowed,
      this.selectedRow.allowedVenueGroups,
    );
  }

  nodeSelect(e) {
    this.venueSelect = e.node.label;
  }

  saveUser() {
    console.log(this.selectedRow);
    if (!isUndefined(this.selectedRow.securityGroup)) {
      this.selectedRow.securityGroupId = this.selectedRow.securityGroup.id;
    } else {
      this.selectedRow.securityGroupId = undefined;
    }

    if (!isUndefined(this.defaultVenueGroup)) {
      this.selectedRow.defaultVenueGroup = this.defaultVenueGroup.data;
    }

    if (!isUndefined(this.allowedVenueGroups)) {
      const allowedVenueGroups = [];
      this.allowedVenueGroups.forEach(el => {
        allowedVenueGroups.push(el.data);
      });
      this.selectedRow.allowedVenueGroups = allowedVenueGroups;
    }

    this.http_updateAnalyticUser(this.selectedRow, (data: any) => {
      console.log('users', data);
      this.showSuccessMessage('User has been updated');
      this.unselectRow();
      this.analyticsUsers = data.payload;
    });
  }

  addNewUser() {
    this.display = true;
  }

  createNewUser() {
    this.http_createNewAnalyticUser(this.newAnalyticsUser, (data: any) => {
      this.showSuccessMessage('User has been created');
      this.unselectRow();
      this.analyticsUsers = data.payload;
    });
    this.display = false;
  }

  deleteUser() {
    this.http_deleteAnalyticsUser({ id: this.selectedRow.id }, (data: any) => {
      this.showSuccessMessage('User has been deleted');
      this.unselectRow();
      this.analyticsUsers = data.payload;
    });
  }

  unselectRow() {
    this.selectedRow = undefined;
  }

  getWebSocketIdentifier(): string {
    return WsConst.ANALYTICS_USERS;
  }

  private groupsToArr(treeNodes: TreeNode[]) {
    const result: TreeNode[] = [];
    if (isUndefined(treeNodes)) {
      return result;
    }
    for (let i = 0; i < treeNodes.length; i++) {
      result.push(treeNodes[i]);
      this.groupsToArr(treeNodes[i].children).forEach(el => {
        result.push(el);
      });
    }
    return result;
  }

  private groupsToAllowedArr(treeNodes: TreeNode[], allowed: string[]) {
    const result: TreeNode[] = [];
    if (isUndefined(treeNodes)) {
      return result;
    }
    for (let i = 0; i < treeNodes.length; i++) {
      if (!isNull(treeNodes[i].data)) {
        if (allowed.indexOf(treeNodes[i].data) !== -1) {
          result.push(treeNodes[i]);
        }
        this.groupsToAllowedArr(treeNodes[i].children, allowed).forEach(el => {
          result.push(el);
        });
      }
    }

    return result;
  }

  private reLoadUsers() {
    this.http_getAllAnalyticUsers((data: any) => {
      console.log('13213', data);
      this.analyticsUsers = data.payload;
    });
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/organization/analytics-users/analytics-users.component.ts